import React from "react";
import { Handshake, ShieldCheck, CheckCircle2 } from "lucide-react";
import { siteData } from "../mock";

const iconMap = { Handshake, ShieldCheck, CheckCircle2 };

export default function WhyUs() {
  return (
    <section className="py-20 md:py-28 bg-jk-cream">
      <div className="max-w-7xl mx-auto px-5 md:px-10">
        <div className="text-[11px] tracking-[0.32em] text-[#b88b4a] mb-5">WHY JK ESTATES</div>
        <h2 className="font-serif text-neutral-900 text-[42px] leading-[1.08] md:text-[68px] md:leading-[1.03] tracking-tight max-w-4xl">
          Real estate, <span className="italic">done the honest way.</span>
        </h2>

        <div className="mt-14 md:mt-16 grid md:grid-cols-3 gap-px bg-[#e7e2d7] border border-[#e7e2d7]">
          {siteData.pillars.map((p) => {
            const Icon = iconMap[p.icon] || Handshake;
            return (
              <div key={p.title} className="bg-jk-cream p-9 md:p-12 group hover:bg-white transition-colors">
                <div className="w-12 h-12 rounded-full border border-[#c6a071]/60 flex items-center justify-center mb-9">
                  <Icon className="w-5 h-5 text-[#b88b4a]" strokeWidth={1.5} />
                </div>
                <h3 className="font-serif text-neutral-900 text-[28px] md:text-[30px] leading-tight mb-5">{p.title}</h3>
                <p className="text-neutral-700 text-[15px] leading-[1.75]">{p.desc}</p>
                <div className="mt-9 h-px w-10 bg-neutral-300 group-hover:w-16 group-hover:bg-[#c6a071] transition-all" />
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
